<script>
    export let height = "100%";
    export let orientation = "vertical";
    export let opacity = 0.05;
    export let style;

    $: vertical = orientation == "vertical";
    $: horizontal = !vertical;
</script>

{#if vertical}
    <hr width="1" height={height} style="opacity: {opacity}; {style}">
{:else}
    <hr {style}>
{/if}

<style>
    hr {
        background: black;
    }
</style>